<template>
  <form class="formContain container">
    <section>
      <label for="fname">Name of the Project</label>
      <input id="fname" v-model="$v.formResponses.name.$model" type="text" />
      <p v-if="errors" class="error">
        <span v-if="!$v.formResponses.name.required">this field is required.</span>
        <span
          v-if="!$v.formResponses.name.minLength"
        >Field must have at least {{ $v.formResponses.name.$params.minLength.min }} characters.</span>
      </p>
    </section>
    <section>
      <label for="femail">Email Associated with the Account</label>
      <input id="femail" v-model="$v.formResponses.email.$model" type="email" />
      <p v-if="errors" class="error">
        <span v-if="!$v.formResponses.email.required">this field is required.</span>
        <span v-if="!$v.formResponses.email.email">Needs to be a valid email.</span>
      </p>
    </section>
    <section>
      <label for="fmisc">(Optional) Is there anything else you'd like to let us know?</label>
      <textarea id="fmisc" v-model="formResponses.misc" />
    </section>
    <section>
      <button
        v-if="uiState !== 'transmitting' && uiState !== 'form submitted'"
        @click.prevent="submitForm"
        class="submit"
        type="submit"
      >Submit</button>
      <p v-else-if="uiState === 'form submitted'" class="success">Hooray! Your form was submitted!</p>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="loader"
        height="50"
        width="50"
        viewBox="0 0 100 100"
      >
        <g fill="teal">
          <path
            d="M49.54175,89.7783125 C45.0405,91.7051875 30.823,86.0026875 28.603,84.7358125 C18.66925,79.0683125 11.54925,69.1026875 9.423,57.8633125 C7.031125,45.2220625 11.13675,31.9308125 19.80675,22.5070625 C29.552375,12.0958125 44.259875,7.2464375 58.30925,9.6776875 C78.782375,13.2208125 93.203625,31.9683125 94.57925,52.1758125 C94.931125,57.3433125 91.027375,61.8170625 85.859875,62.1689375 C80.692375,62.5208125 76.218,58.6170625 75.866125,53.4495625 C75.85675,53.3126875 75.8505,53.1764375 75.847375,53.0408125 L75.82925,52.1758125 C75.82925,52.1758125 75.81925,51.6883125 75.8005,50.7751875 C75.79925,50.5476875 75.797375,50.2945625 75.7955,50.0158125 C75.712375,37.5833125 64.842375,26.4714375 52.946125,24.2745625 C19.49425,18.0976875 7.18175,67.2176875 35.5805,82.0920625 C35.903,82.2776875 36.2205,82.4608125 36.533,82.6401875 C36.853625,82.8020625 37.17925,82.9389375 37.49425,83.0864375 C38.129875,83.3783125 38.742375,83.6595625 39.331125,83.9301875 C40.53925,84.3933125 41.683625,84.7483125 42.7105,85.1120625 C43.7405,85.3564375 44.659875,85.5745625 45.459875,85.7639375 C45.84925,85.8764375 46.2705,85.9226875 46.648,85.9720625 C47.024875,86.0226875 47.36675,86.0683125 47.673625,86.1095625 C48.899875,86.2733125 49.553625,86.3608125 49.553625,86.3608125 C50.394875,86.4739375 50.987375,87.2408125 50.887375,88.0839375 C50.788,88.9070625 50.30425,89.4520625 49.54175,89.7783125"
            fill-rule="evenodd"
          />
        </g>
      </svg>
      <div>
        <p v-if="$v.$anyError && uiState === 'submit clicked'" class="error">
          The form above has errors,
          <br />please fix the errors and resubmit
        </p>
        <p v-else-if="!$v.$dirty && uiState === 'submit clicked'" class="error">
          The form above is empty,
          <br />cmon y'all you can't submit an empty form!
        </p>
      </div>
    </section>
  </form>
</template>

<script>
import {
  required,
  minLength,
  email,
  sameAs,
  url
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      uiState: "submit not clicked",
      errors: false,
      empty: true,
      formResponses: {
        name: null,
        email: null,
        misc: null
      }
    };
  },
  validations: {
    formResponses: {
      name: {
        required,
        minLength: minLength(2)
      },
      email: {
        required,
        email
      }
    }
  },
  methods: {
    submitForm() {
      this.empty = !this.$v.formResponses.$anyDirty;
      this.errors = this.$v.formResponses.$anyError;
      if (this.errors === false && this.empty === false) {
        this.uiState = "transmitting";
        (async () => {
          try {
            const data = {
              name: "no name provided",
              projectName: this.formResponses.name,
              email: this.formResponses.email,
              notes: this.formResponses.misc
            };
            const response = await fetch(
              "https://supportapi.services.netlify.com/ticket/opensource?type=public-good",
              {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                  "Content-Type": "application/json"
                }
              }
            );
            this.formResponses = {
              name: null,
              email: null,
              misc: null
            };
            this.uiState = "form submitted";
            const json = await response.json();
            console.log("Success:", JSON.stringify(json));
          } catch (error) {
            console.error("Error:", error);
          }
        })();
      } else {
        this.uiState = "submit clicked";
      }
    }
  }
};
</script>

<style>
label {
  margin: 20px 0 10px;
  display: block;
}

button {
  position: relative;
  z-index: 1;
  display: inline-block;
  vertical-align: middle;
  padding: 0.5em 1em;
  outline: 0;
  font-family: inherit;
  font-size: 1em;
  font-weight: 500;
  line-height: 1.2222222;
  text-align: center;
  text-decoration: none;
  border: none;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);
  cursor: pointer;
  background: #00b09f;
  color: #fff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: all 0.15s ease;
}

select {
  font-size: 18px;
}

.error {
  text-transform: uppercase;
  font-size: 12px;
  color: red;
  position: absolute;
}

.success {
  text-transform: uppercase;
  font-size: 16px;
  color: teal;
  position: absolute;
}

.formContain section {
  padding-bottom: 30px;
  position: relative;
}

.loader {
  animation: spinning 0.65s ease-in-out infinite;
}

@keyframes spinning {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
